"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Stack = _interopRequireDefault(require("../Stack"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _LogTextMessage = _interopRequireDefault(require("./LogTextMessage"));
var _intlTs = require("@gogame/intl-ts");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LogText = function LogText(_ref) {
  var _ref$date = _ref.date,
    date = _ref$date === void 0 ? '' : _ref$date,
    _ref$dateTemplate = _ref.dateTemplate,
    dateTemplate = _ref$dateTemplate === void 0 ? 'LLL' : _ref$dateTemplate,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? '' : _ref$status,
    action = _ref.action,
    user = _ref.user,
    _ref$timeZone = _ref.timeZone,
    timeZone = _ref$timeZone === void 0 ? 'local' : _ref$timeZone,
    description = _ref.description,
    error = _ref.error,
    children = _ref.children;
  var hasTextMessage = action || user || description;
  var hasChildren = _react["default"].Children.toArray(children).some(function (child) {
    return /*#__PURE__*/_react["default"].isValidElement(child);
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
      spacing: 1,
      direction: 'row',
      alignItems: 'center',
      children: [date && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
        variant: 'caption',
        color: 'text.secondary',
        "data-cy": 'log-date',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_intlTs.DateValueFormatter, {
          value: date,
          template: dateTemplate,
          timeZone: timeZone
        })
      }), date && status && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
        color: 'text.secondary',
        children: "|"
      }), status && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
        color: 'inherit',
        variant: 'caption',
        "data-cy": 'log-status',
        children: status
      })]
    }), hasTextMessage && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LogTextMessage["default"], {
      action: action,
      user: user,
      description: description,
      error: error
    }), hasChildren && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack["default"], {
      direction: 'row',
      flexWrap: 'wrap',
      sx: {
        padding: '4px 0',
        margin: '0 -4px'
      },
      children: children
    })]
  });
};
LogText.propTypes = {
  date: _propTypes["default"].string.isRequired,
  dateTemplate: _propTypes["default"].string,
  status: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  action: _propTypes["default"].string.isRequired,
  user: _propTypes["default"].string,
  timeZone: _propTypes["default"].string
};
var _default = exports["default"] = LogText;